import 'parsleyjs'
import 'javascripts/impression.js'

/* stylesheet */
import 'stylesheets/landingpages/download_for_qualified_lead_form.less'

if (window.beacon_url !== "undefined") {
    let lql  = function leftQualifiedLead() {
        navigator.sendBeacon(window.beacon_url);
    };
    window.addEventListener('unload', lql);

    $("#qualified-lead-form").submit(function() {
        window.removeEventListener('unload', lql)
    });
}

$('body').on('change', '.answer-dropdown', function() {
    if ($(this).val() == 'Other') {
        $(`#${$(this).attr('id')}_other_input`).show();
        $(`#${$(this).attr('id')}_other_input`).prop('required', true); // text answer should be required if Other option was selected
    } else {
        $(`#${$(this).attr('id')}_other_input`).hide();
        $(`#${$(this).attr('id')}_other_input`).prop('required', false);
    }
});
